/**
 * Mobile Quick Add — bag icon opens size sheet, then cart + drawer.
 * Used by Product information v1 carousels and You May Also Like v1.
 */
(function () {
  'use strict';
  if (window.RafMobileQuickAdd) return;
  window.RafMobileQuickAdd = true;

  var modal = null;
  var lastFocus = null;
  var current = null;

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + (root.slice(-1) === '/' ? '' : '/') + 'cart/add.js';
  }

  function optionIndex(names, needle) {
    var list = names || [];
    for (var i = 0; i < list.length; i++) {
      var n = String(list[i] || '').toLowerCase();
      if (n.indexOf(needle) !== -1) return i;
    }
    return -1;
  }

  function sizeIndex(names) {
    return optionIndex(names, 'size');
  }

  function colorIndex(names) {
    var i = optionIndex(names, 'color');
    if (i >= 0) return i;
    return optionIndex(names, 'colour');
  }

  function uniqueValues(data, idx, filterIdx, filterVal) {
    var values = [];
    var seen = {};
    (data.variants || []).forEach(function (v) {
      var opts = v.options || [];
      if (filterIdx >= 0 && filterVal && opts[filterIdx] !== filterVal) return;
      var label = opts[idx];
      if (!label || seen[label]) return;
      seen[label] = true;
      values.push(label);
    });
    return values;
  }

  function matchVariant(data, sizeVal, colorVal) {
    var names = data.options || [];
    var sIdx = sizeIndex(names);
    var cIdx = colorIndex(names);
    var found = null;
    var variants = data.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [];
      if (sIdx >= 0 && sizeVal && opts[sIdx] !== sizeVal) continue;
      if (cIdx >= 0 && colorVal && opts[cIdx] !== colorVal) continue;
      if (v.available) return v;
      if (!found) found = v;
    }
    return found;
  }

  function sizeRows(data, colorVal) {
    var names = data.options || [];
    var sIdx = sizeIndex(names);
    var rows = [];
    if (sIdx < 0) return rows;
    uniqueValues(data, sIdx, colorIndex(names), colorVal).forEach(function (label) {
      var v = matchVariant(data, label, colorVal);
      rows.push({
        label: label,
        id: v ? v.id : '',
        available: !!(v && v.available),
        price: (v && v.price) || data.price
      });
    });
    return rows;
  }

  function colorRows(data) {
    var names = data.options || [];
    var cIdx = colorIndex(names);
    var rows = [];
    if (cIdx < 0) return rows;
    uniqueValues(data, cIdx, -1, '').forEach(function (label) {
      var v = matchVariant(data, '', label);
      rows.push({
        label: label,
        id: v ? v.id : '',
        available: !!(v && v.available),
        price: (v && v.price) || data.price,
        image: (v && v.image) || data.image
      });
    });
    return rows;
  }

  function imageForColor(data, colorVal) {
    var names = data.options || [];
    var cIdx = colorIndex(names);
    var variants = data.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (cIdx >= 0 && colorVal && (v.options || [])[cIdx] !== colorVal) continue;
      if (v.image) return v.image;
    }
    return data.image || '';
  }

  function priceForColor(data, colorVal) {
    var v = matchVariant(data, '', colorVal);
    return (v && v.price) || data.price || '';
  }

  function plusSvg() {
    return '<span class="raf-mqa__plus" aria-hidden="true"><svg viewBox="0 0 12 12" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 2v8M2 6h8"/></svg></span>';
  }

  var CSS_COLORS = {
    black: '#111111',
    white: '#ffffff',
    grey: '#8a8a8a',
    gray: '#8a8a8a',
    navy: '#1b2a4a',
    blue: '#2c4a7c',
    green: '#3d5c3a',
    olive: '#556b2f',
    khaki: '#c3b091',
    tan: '#d2b48c',
    beige: '#d8c3a5',
    brown: '#6b4a2b',
    red: '#8b1e1e',
    burgundy: '#6b1c2a',
    pink: '#d48aa0',
    purple: '#5c3d6e',
    orange: '#c45c26',
    yellow: '#d4b43c',
    gold: '#c4a35a',
    silver: '#c0c0c0',
    charcoal: '#36454f',
    ivory: '#fffff0',
    cream: '#f5f0e1',
    camo: '#4a5d3a',
    rosin: '#4a5c32',
    sand: '#c2b280',
    stone: '#8a8680'
  };

  function guessCssColor(label) {
    var words = String(label || '').toLowerCase().replace(/[^a-z0-9\s-]/g, ' ').split(/\s+/);
    var i;
    for (i = 0; i < words.length; i++) {
      if (CSS_COLORS[words[i]]) return CSS_COLORS[words[i]];
    }
    for (i = 0; i < words.length; i++) {
      if (words[i]) return words[i];
    }
    return '#c8c8c8';
  }

  function swatchStyle(label, data) {
    var map = (data && data.swatches) || {};
    var s = map[label] || {};
    if (s.image) {
      return 'background-image:url(' + String(s.image).replace(/"/g, '') + ')';
    }
    if (s.hex) return 'background-color:' + String(s.hex).replace(/"/g, '');
    if (s.css && CSS_COLORS[String(s.css).toLowerCase()]) {
      return 'background-color:' + CSS_COLORS[String(s.css).toLowerCase()];
    }
    if (s.css) return 'background-color:' + String(s.css).replace(/"/g, '');
    return 'background-color:' + guessCssColor(label);
  }

  function swatchHtml(label, data) {
    return '<span class="raf-mqa__swatch" style="' + swatchStyle(label, data) + '" aria-hidden="true"></span>';
  }

  function choiceLabel(label, data, withSwatch) {
    if (withSwatch) {
      return (
        '<span class="raf-mqa__choice">' +
        swatchHtml(label, data) +
        '<span class="raf-mqa__size">' + escapeHtml(label) + '</span></span>'
      );
    }
    return '<span class="raf-mqa__size">' + escapeHtml(label) + '</span>';
  }

  function rowHtml(row, selected, data, withSwatch) {
    if (row.available) {
      return (
        '<button type="button" class="raf-mqa__row' + (selected ? ' is-selected' : '') +
        '" data-raf-mqa-add data-variant-id="' + String(row.id) +
        '">' + choiceLabel(row.label, data, withSwatch) +
        '<span class="raf-mqa__add">Add to bag ' + plusSvg() + '</span></button>'
      );
    }
    return (
      '<div class="raf-mqa__row is-unavailable">' + choiceLabel(row.label, data, withSwatch) +
      '<span class="raf-mqa__oos">Out of stock</span></div>'
    );
  }

  function colorRowHtml(row, selected, data) {
    return (
      '<button type="button" class="raf-mqa__row' + (selected ? ' is-selected' : '') +
      '" data-raf-mqa-color="' + escapeHtml(row.label) +
      '">' + choiceLabel(row.label, data, true) +
      '<span class="raf-mqa__add">' + (selected ? 'Selected' : 'Select') +
      '</span></button>'
    );
  }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'raf-mqa';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="raf-mqa__backdrop" data-raf-mqa-close></div>' +
      '<div class="raf-mqa__sheet" role="dialog" aria-modal="true" aria-labelledby="raf-mqa-heading">' +
        '<header class="raf-mqa__head">' +
          '<h2 class="raf-mqa__title" id="raf-mqa-heading">Quick add</h2>' +
          '<button type="button" class="raf-mqa__close" data-raf-mqa-close aria-label="Close">×</button>' +
        '</header>' +
        '<div class="raf-mqa__product">' +
          '<img class="raf-mqa__thumb" alt="" width="72" height="72">' +
          '<div class="raf-mqa__meta">' +
            '<p class="raf-mqa__name"></p>' +
            '<p class="raf-mqa__color" hidden></p>' +
            '<p class="raf-mqa__price"></p>' +
          '</div>' +
        '</div>' +
        '<div class="raf-mqa__colors" hidden>' +
          '<p class="raf-mqa__label">Select color</p>' +
          '<div class="raf-mqa__color-list"></div>' +
        '</div>' +
        '<div class="raf-mqa__sizes">' +
          '<p class="raf-mqa__label raf-mqa__size-label">Select size</p>' +
          '<div class="raf-mqa__list"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-raf-mqa-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      var colorBtn = e.target.closest('[data-raf-mqa-color]');
      if (colorBtn) {
        e.preventDefault();
        selectColor(colorBtn.getAttribute('data-raf-mqa-color') || '');
        return;
      }
      var row = e.target.closest('[data-raf-mqa-add]');
      if (!row || row.classList.contains('is-unavailable')) return;
      e.preventDefault();
      addRow(row);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    return modal;
  }

  function renderProduct(data, colorVal) {
    var el = modal;
    el.querySelector('.raf-mqa__name').textContent = data.title || '';
    el.querySelector('.raf-mqa__price').textContent = priceForColor(data, colorVal);
    var colorEl = el.querySelector('.raf-mqa__color');
    if (colorVal) {
      colorEl.textContent = colorVal;
      colorEl.hidden = false;
    } else {
      colorEl.textContent = '';
      colorEl.hidden = true;
    }
    var img = el.querySelector('.raf-mqa__thumb');
    var src = imageForColor(data, colorVal);
    if (src) {
      img.src = src;
      img.hidden = false;
    } else {
      img.removeAttribute('src');
      img.hidden = true;
    }
  }

  function renderLists(data, colorVal) {
    var el = modal;
    var names = data.options || [];
    var cIdx = colorIndex(names);
    var sIdx = sizeIndex(names);
    var colorsWrap = el.querySelector('.raf-mqa__colors');
    var sizesWrap = el.querySelector('.raf-mqa__sizes');
    var colorList = el.querySelector('.raf-mqa__color-list');
    var sizeList = el.querySelector('.raf-mqa__list');
    var sizeLabel = el.querySelector('.raf-mqa__size-label');

    if (cIdx >= 0 && sIdx >= 0) {
      colorsWrap.hidden = false;
      sizesWrap.hidden = false;
      sizeLabel.textContent = 'Select size';
      colorList.innerHTML = colorRows(data).map(function (row) {
        return colorRowHtml(row, row.label === colorVal, data);
      }).join('');
      sizeList.innerHTML = sizeRows(data, colorVal).map(function (row) {
        return rowHtml(row, false, data, false);
      }).join('');
      return;
    }

    if (cIdx >= 0 && sIdx < 0) {
      colorsWrap.hidden = false;
      sizesWrap.hidden = true;
      colorList.innerHTML = colorRows(data).map(function (row) {
        return rowHtml(row, false, data, true);
      }).join('');
      return;
    }

    colorsWrap.hidden = true;
    sizesWrap.hidden = false;
    sizeLabel.textContent = sIdx >= 0 ? 'Select size' : 'Select option';
    var rows = sIdx >= 0 ? sizeRows(data, '') : (data.variants || []).map(function (v) {
      return {
        label: (v.options || []).join(' / ') || 'Add to bag',
        id: v.id,
        available: !!v.available,
        price: v.price || data.price
      };
    });
    sizeList.innerHTML = rows.map(function (row) {
      return rowHtml(row, false, data, false);
    }).join('');
  }

  function selectColor(colorVal) {
    if (!current || !current.data) return;
    current.color = colorVal;
    renderProduct(current.data, colorVal);
    renderLists(current.data, colorVal);
  }

  function openModal(data) {
    var el = ensureModal();
    var names = data.options || [];
    var colorVal = data.color || '';
    if (!colorVal && colorIndex(names) >= 0) {
      var colors = uniqueValues(data, colorIndex(names), -1, '');
      colorVal = colors[0] || '';
    }

    if (data.hasOnlyDefault) {
      var only = (data.variants || [])[0];
      if (only && only.available) {
        addToCart(only.id);
        return;
      }
    }

    current = { data: data, color: colorVal };
    lastFocus = document.activeElement;
    renderProduct(data, colorVal);
    renderLists(data, colorVal);

    var hasContent = el.querySelector('.raf-mqa__row');
    if (!hasContent) return;

    el.hidden = false;
    document.documentElement.classList.add('raf-mqa-open');
    var closeBtn = el.querySelector('.raf-mqa__close');
    if (closeBtn) {
      try { closeBtn.focus({ preventScroll: true }); } catch (err) { closeBtn.focus(); }
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('raf-mqa-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (e) {}
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openCartDrawer(detail) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: detail, bubbles: true }));
    if (window.CartDrawerRaf && typeof window.CartDrawerRaf.open === 'function') {
      window.CartDrawerRaf.open();
    }
    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.getCart();
    }
  }

  function addToCart(variantId, rowEl) {
    if (!variantId) return Promise.resolve();
    if (rowEl) rowEl.classList.add('is-loading');
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            throw new Error((body && (body.description || body.message)) || 'Could not add to cart');
          }
          return body;
        });
      })
      .then(function (item) {
        closeModal();
        openCartDrawer(item);
      })
      .catch(function (err) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[Mobile Quick Add] failed', err);
        }
      })
      .then(function () {
        if (rowEl) rowEl.classList.remove('is-loading');
      });
  }

  function addRow(row) {
    addToCart(row.getAttribute('data-variant-id'), row);
  }

  function readPayload(btn) {
    var script = btn.parentNode && btn.parentNode.querySelector('[data-raf-mqa-json]');
    if (!script) script = btn.nextElementSibling;
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-raf-mqa]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var data = readPayload(btn);
      if (!data) return;
      openModal(data);
    },
    true
  );
})();
